import Vue from "vue";
import Router from "vue-router";

import store from "../store";
import Main from "../features/company.feature/containers/Company.container";
import LoginView from "../main/user.main/LoginView";
import NotFoundView from "../main/user.main/NotFoundView";
import SettingsContainer from "../features/settings.feature/containers/Settings.container";
import Tasks from "../features/tasks.feature/containers/Tasks.container";
import Statistics from "../features/statistics.feature/containers/Statistics.container";
import Games from "../features/games.feature/containers/Games.container";
import Instrucion from "../features/instruction.feature/containers/Instruction.container";
import Security from "../features/security.feature/containers/Security.container";
import Quiz from "../features/quizs.feature/containers/Quiz.container";

import ShiftContainer from "../features/shifts.feature/containers/Shifts.container";
import Finance from "../features/finance.feature/containers/FinanceTable.container";
import Projects from "../features/projects.feature/Projects.container";
import Contacts from "../features/projects.feature/contacts/containers/Contacts.container";
import Inventory from "../features/projects.feature/inventory/containers/Inventory.container";
import Orders from "../features/projects.feature/orders/containers/MainOrdersContainer";
import Users from "../features/users.feature/containers/Users.container";
import Brokers from "../features/brokers.feature/containers/Brokers.container";
import Chat from "../features/chat.feature/containers/chat.container";
import DigitalSignatureForm from "../features/projects.feature/digital_signature_form/containers/DigitalSignatureForm.container";
import SkySimulator from "../features/projects.feature/sky_simulator/containers/SkySimulator.container";
import Clients1 from "../features/clients1.feature/containers/Clients1.container";
import Tasks1 from "../features/tasks1.feature/containers/Tasks1.container";
import Shifts1 from "../features/shifts1.feature/containers/Shifts1.container";
import Stats1 from "../features/statistics1.feature/containers/Stats1.container";
import Users1 from "../features/users1.feature/containers/Users1.container";
import Finance1 from "../features/finance1.feature/containers/Finance1.container";
import Brokers1 from "../features/brokers1.feature/containers/Brokers1.container";
import Chat1 from "../features/chat1.feature/containers/Chat1.container";
import Security1 from "../features/security1.feature/containers/Security1.container";
import Communications1 from "../features/communications1.feature/containers/Communications1.container";
import Affiliation1 from "../features/affiliation1.feature/containers/Affiliation1.container";
import Games1 from "../features/games1.feature/containers/Games1.container";
import Quiz1 from "../features/quizs1.feature/containers/Quiz1.container";
import Settings1 from "../features/settings1.feature/containers/Settings1.container";
import Instruction1 from "../features/instruction1.feature/containers/Instruction1.container";
import Profile1 from "../features/profile1.feature/containers/Profile1.container";

Vue.use(Router);
export default new Router({
  mode: "history",
  linkActiveClass: "active",
  routes: [
    {
      path: "/clients1",
      name: "Clients1",
      component: Clients1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },
    {
      path: "/clients1/lead/:leadId",
      name: "ClientLead",
      component: Clients1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/tasks1",
      name: "Tasks1",
      component: Tasks1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/shifts1",
      name: "Shifts1",
      component: Shifts1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/stats1",
      name: "Stats1",
      component: Stats1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/users1",
      name: "Users1",
      component: Users1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/finance1",
      name: "Finance1",
      component: Finance1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/brokers1",
      name: "Brokers1",
      component: Brokers1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/chat1",
      name: "Chat1",
      component: Chat1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/security1",
      name: "Security1",
      component: Security1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/communications1",
      name: "Communications1",
      component: Communications1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/affiliation1",
      name: "Affiliation1",
      component: Affiliation1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/games1",
      name: "Games1",
      component: Games1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/quiz1",
      name: "Quiz1",
      component: Quiz1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/settings1",
      name: "Settings1",
      component: Settings1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/instruction1",
      name: "Instruction1",
      component: Instruction1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/profile1",
      name: "Profile1",
      component: Profile1,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) { next("/login"); return; }
        next();
      }
    },

    {
      path: "/",
      name: "Main",
      component: Main,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        next();
      }
    },
    {
      path: "/chat",
      name: "chat.container",
      component: Chat,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        next();
        // if (!store.state["clients/isVisitedMainPage"]) {   //TODO temporary disabled 15/02/21
        //   next("/");
        // }

        // const perm = [1, 2, 3, 10, 12];
        // if (perm.some(role => role === store.getters["clients/userRole"])) {
        //   next();
        // }
      }
    },
    {
      path: "/tasks",
      name: "Tasks",
      component: Tasks,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        next();
      }
    },
    {
      path: "/users",
      name: "Users",
      component: Users,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        next();
      }
    },
    {
      path: "/brokers",
      name: "Brokers",
      component: Brokers,
      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        const perm = [1, 2, 3, 4, 12];
        if (perm.some(role => role === store.getters["user/userRole"])) {
          next();
        }
      }
    },
    {
      path: "/login",
      name: "LoginView",
      component: LoginView,

      beforeEnter: function(to, from, next) {
        if (store.getters["user/isLogged"]) {
          next("/");
          return;
        }

        next();
      }
    },
    {
      path: "/quiz",
      name: "QUIZ",
      component: Quiz,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        const perm = [1, 2, 3, 4, 5, 6, 7, 12];
        if (perm.some(role => role === store.getters["user/userRole"])) {
          next();
        }
      }
    },

    {
      path: "/games",
      name: "Games",
      component: Games,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        const perm = [1, 2, 3, 4, 5, 6, 7, 12];
        if (perm.some(role => role === store.getters["user/userRole"])) {
          next();
        }
      }
    },
    {
      path: "/settings",
      name: "SettingsContainer",
      component: SettingsContainer,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        const perm = [1, 2, 3, 4, 12];
        if (perm.some(role => role === store.getters["user/userRole"])) {
          next();
        }
      }
    },
    {
      path: "/instruction",
      name: "InstructionContainer",
      component: Instrucion,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        next();
      }
    },
    {
      path: "/stats",
      name: "StatisticsContainer",
      component: Statistics,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        const perm = [1, 2, 3, 4, 12];
        if (perm.some(role => role === store.getters["user/userRole"])) {
          next();
        }
      }
    },
    {
      path: "/shifts",
      name: "MainShiftsContainer",
      component: ShiftContainer,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        const perm = [1, 2, 3, 4, 12];
        if (perm.some(role => role === store.getters["user/userRole"])) {
          next();
        }
      }
    },
    {
      path: "/finance",
      name: "MainFinanceContainer",
      component: Finance,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        const perm = [1, 2, 3, 10, 12];
        if (perm.some(role => role === store.getters["user/userRole"])) {
          next();
        }
      }
    },
    {
      path: "/security",
      name: "Security",
      component: Security,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        const perm = [1, 2, 3, 12];
        if (perm.some(role => role === store.getters["user/userRole"])) {
          next();
        }
      }
    },
    {
      path: "/project",
      name: "MainProjectContainer",
      component: Projects,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        const perm = [1, 2, 3, 10, 12];
        if (perm.some(role => role === store.getters["user/userRole"])) {
          next();
        }
      }
    },
    {
      path: "/form",
      name: "DigitalSignatureForm",
      component: DigitalSignatureForm,

      beforeEnter: function(to, from, next) {
        // if (!store.getters["user/isLogged"]) {
        // next("/login");
        return next();
        // }
        // const perm = [1, 2, 3,4, 10, 12];
        // if (perm.some(role => role === store.getters["user/userRole"])) {
        //   next();
        // }
      }
    },
    {
      path: "/contacts",
      name: "MainContactsContainer",
      component: Contacts,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        const perm = [1, 2, 3, 10, 12];
        if (perm.some(role => role === store.getters["user/userRole"])) {
          next();
        }
      }
    },
    {
      path: "/inventory",
      name: "MainInventoryContainer",
      component: Inventory,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        const perm = [1, 2, 3, 10, 12];
        if (perm.some(role => role === store.getters["user/userRole"])) {
          next();
        }
      }
    },
    {
      path: "/orders",
      name: "MainOrdersContainer",
      component: Orders,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {   //TODO temporary disabled 15/02/21
        //   next("/");
        // }

        const perm = [1, 2, 3, 10, 12];
        if (perm.some(role => role === store.getters["user/userRole"])) {
          next();
        }
      }
    },
    {
      path: "/sky_simulator",
      name: "SkySimulator",
      component: SkySimulator,

      beforeEnter: function(to, from, next) {
        if (!store.getters["user/isLogged"]) {
          next("/login");
          return;
        }
        // if (!store.state["clients/isVisitedMainPage"]) {
        //   next("/");
        // }
        const perm = [1, 2, 3, 10, 12];
        if (perm.some(role => role === store.getters["user/userRole"])) {
          next();
        }
      }
    },
    {
      path: "*",
      component: NotFoundView
    }
  ]
});
